<template lang="pug">
    .tab-content.timeline-container(v-loader-overlay="progressTracking")
        .timeline
            .timeline-row(v-if="!!(tracking && tracking.length)" v-for="(item, i) in tracking" v-bind:class="{ last: i == tracking.length - 1 }")
                .date-time
                    .date {{moment(item.date).tz($root.userTimezone).format('DD.MM.YYYY')}}
                    .time {{moment(item.date).tz($root.userTimezone).format('HH:mm')}}
                .dot-container
                    .dot-line(v-bind:style="(item.status && item.status.color ? ('background-color: ' + item.status.color + ';') : '')")
                    .dot(v-bind:style="(item.status && item.status.color ? ('border-color: ' + item.status.color + ';') : '')")
                
                .timeline-content
                    .status(v-if="item.status")
                        .text(v-bind:style="(item.status && item.status.color ? ('color: ' + item.status.color + ';') : '')") {{ item.status.name }}
                    .timeline-text-content(v-bind:style="(item.status && item.status.color ? ('border-color: ' + item.status.color + ';') : '')")
                        .track(v-if="item.stock")
                            span № Трека:
                            | {{ item.id }}
                        .routelist(v-if="item.route_list_id")
                            span Маршрутный лист:
                            | {{ '№' + item.route_list_id }}
                        .stock(v-if="item.stock")
                            span Склад:
                            | {{ item.stock.name }}
                        .responsible(v-if="item.responsible")
                            span Ответственный:
                            | {{ ((item.responsible.fio) ? (item.responsible.fio + ', ') : '') + item.responsible.login }}
                        .responsible(v-if="item.creator")
                            span Создатель:
                            | {{ ((item.creator.fio) ? (item.creator.fio + ', ') : '') + item.creator.login }}

                    .delete(v-if="isUserAdmin")
                        //md-button.md-icon-button.small.md-dense(@click.stop="deleteTracking(item.id)"): md-icon close  
                        //md-button.md-icon-button.small.md-dense(@click.stop="deleteTracking(item.id)"): md-icon close
                        md-button.md-icon-button.small.md-dense(@click.stop="deleteTracking(item.id)")
                            md-icon close
                            md-tooltip(md-direction="bottom" md-delay="500") Удалить
                    
            #tracking-form(v-if="showTrackingForm")
                z-select(
                    v-if="statuses && statuses.length" v-model="editedTracking.status_id" label="Статус" id="status_id" name="status_id"
                    v-bind:error="errors.first('status_id')" data-vv-name="status_id" v-bind:data-vv-as="' '" v-validate="{'required': true}"
                )
                    option(v-for="status in statuses" v-bind:key="status.id" v-bind:value="status.id") {{ status.name }}

                z-select(
                    v-if="stocks && stocks.length" v-model="editedTracking.stock_id" label="Склад" id="stock_id" name="stock_id"
                    v-bind:error="errors.first('stock_id')" data-vv-name="stock_id" v-bind:data-vv-as="' '" v-validate="{'required': true}"
                )
                    option(v-for="stock in stocks" v-bind:key="stock.id" v-bind:value="stock.id") {{ stock.name }}

                z-select(
                    v-if="usersOfStock && usersOfStock.length" v-model="editedTracking.responsible_id" label="Ответственный" id="responsible_id" name="responsible_id"
                    v-bind:error="errors.first('responsible_id')" data-vv-name="responsible_id" v-bind:data-vv-as="' '" v-validate="{'required': true}"
                )
                    option(v-for="user in usersOfStock" v-bind:key="user.pivot.user_id" v-bind:value="user.pivot.user_id") {{ user.login }}

                z-select(
                    v-if="routeLists && routeLists.length"  v-model="editedTracking.route_list_id"  label="Маршрутный лист" id="route_list_id" name="route_list_id"
                    v-validate="{'required': (selectedStatus && !(['storekeeper_accepted_from_client', 'storekeeper_issued_to_client', 'website_request'].indexOf(selectedStatus.code)+1))}"
                    v-bind:error="errors.first('route_list_id')" data-vv-name="route_list_id" v-bind:data-vv-as="' '"
                )
                    option(v-for="item in routeLists" v-bind:key="item.id" v-bind:value="item.id") {{ item.label }}

                md-field(v-bind:class="{ 'md-invalid': errors.has('date'), 'md-has-value': editedTracking.date }")
                    label Дата
                    datetime(
                        v-model="editedTracking.date" input-class="md-input" type="datetime" v-bind:use12-hour="false" v-bind:week-start="1" v-bind:phrases="{ ok: 'Ок', cancel: 'Отмена' }"
                        v-bind:error="errors.first('date')" data-vv-name="date" v-bind:data-vv-as="' '" v-validate="{'required': true}"
                    )
                    md-button.md-icon-button.md-dense(@click="editedTracking.date = ''"): md-icon close
                    span.md-error(v-show="errors.has('date')") {{ errors.first('date') }}

                md-dialog-actions
                    md-button(class="md-accent" @click="showTrackingForm = false") Отмена
                    md-button(class="md-primary" @click="saveTracking") Сохранить

            z-button.add-btn(v-if="$props.freight && $props.freight.id && !$props.block && isUserAdmin" v-on:click="addTracking" light) Добавить трекинговую отметку
</template>
<script>
    import ZButton from '@/components/ZButton';
    import ZSelect from '@/components/ZSelect';
    import moment from "moment"
    export default {
        name: 'tracking',
        props: {
            freight: {
                type: Object,
                default: () => {}
            },
            load: {
                type: Boolean,
                defalt: false
            },
            block: {
                type: Boolean,
                default: false
            }
        },
        components: {
          ZButton, ZSelect
        },
        data() {
            return {
                loaderName: 'load-deal-tracking-card',
                tracking: [],
                editedTracking: {},
                showTrackingForm: false,
                usersOfStock: [],
                routeLists: []
            }
        },
        computed: {
            progressTracking() {
                return this.progressObj[this.loaderName];
            },
            progressObj() {
                return this.$store.state.progressObj;
            },
            statuses() {
                return this.$store.state.stock.freight_statuses
            },
            stocks() {
                return this.$store.state.stock.stocks
            },
            user() {
                return this.$store.state.users.current;
            },
            isUserAdmin() {
                return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('administrators')+1) : false;
            },
            selectedStatus() {
                if (!this.editedTracking || !this.editedTracking.status_id) return;
                return this.statuses.find(item => parseInt(item.id) === this.editedTracking.status_id);
            }
        },
        watch: {
            'load'(load) {
                if (!load) return;
                this.getStatuses(1, 999, 'id', 'asc');
                this.getStocks();
                //Если идёт клонирование заявки
                if (this.$route.query && this.$route.query.clone_id) return;
                if (this.$props.freight && this.$props.freight.id) this.getTracking(1, 100, false, false, {model: [['freight_id', '=', this.$props.freight.id]], relation: []});
            },
            'editedTracking.stock_id'(val) {
                let existUserIds = [];
                if (this.stocks && this.stocks.length) this.stocks.map(item => {
                    if (item.id == val) {
                        this.usersOfStock = Object.assign([], item.responsibles);
                        existUserIds = item.responsibles.map(item => parseInt(item.pivot.user_id));
                    }
                });
                if (existUserIds.indexOf(parseInt(this.editedTracking.responsible_id)) == -1)
                    this.editedTracking.responsible_id = null;
            },
            '$props.freight.id'(id) {
                if (!this.$props.freight || !this.$props.freight.id) return;
                if (this.$route.query && this.$route.query.clone_id) return;
                this.getTracking(1, 100, false, false, {
                    model: [['freight_id', '=', this.$props.freight.id]], relation: []
                });
                this.getFreightRouteList();
            }
        },
        methods: {
            getTracking(page, count, order_by, order_type, filter) {
                this.$store.commit('showProgressBar', this.loaderName);
                let data = {
                    page:       (page)       ? page : 1,
                    order_by:   (order_by)   ? order_by : 'id',
                    order_type: (order_type) ? order_type : 'asc',
                    count:      (count)      ? count : 10,
                    filter:     (filter)     ? filter : {model: [], relation: []}
                };
                return this.$store.dispatch('stock/getFreightTracking', data).then(r => {
                    if (r) {
                        this.tracking = Object.assign([], r.data);
                        if (this.tracking.length && this.tracking[ (this.tracking.length - 1) ]) {
                            let Current = Object.assign({}, this.tracking[ (this.tracking.length - 1) ]);
                            delete Current.freight;
                            delete Current.responsible;
                            delete Current.stock;
                            this.$emit('change', {tracking: Current, tracking_id: Current.id});
                        }
                    }
                }).catch(() => null).finally(() => this.$store.commit('hideProgressBar', this.loaderName));
            },
            getStatuses(page, count, orderBy, orderType) {
                this.$store.dispatch('stock/getTrackingStatuses', {
                    page: page, order_by: orderBy, order_type: orderType, count: count
                }).catch(() => null)
            },
            getStocks() {
                this.$store.dispatch('stock/getStocks', { cache: true }).catch(() => null);
            },
            getFreightRouteList() {
                if (!this.$props.freight || !this.$props.freight.id) return;
                this.$store.commit('showProgressBar', this.loaderName);
                return this.$store.dispatch('deals/findRouteLists', {
                    page: 1, count: 50, custom_filter: {freight_id: [this.$props.freight.id]}
                }).then(r => {
                    if (r && r.length) this.routeLists = Object.assign([], r.filter(item => {
                        return ((item.status && item.status.code !== 'complete') || !item.status);
                    }).map(item => {
                        item.label = ('№' + item.id + ', ' + item.type_name);
                        if (parseInt(item.type) === 1 && item.stock) item.label += (' ('  + item.stock.name + ')');
                        if (parseInt(item.type) === 2 && item.from_stock && item.to_stock) item.label += (' ('  + item.from_stock.name + ' - ' + item.to_stock.name + ')');
                        return item;
                    }));
                }).catch(() => null).finally(() => this.$store.commit('hideProgressBar', this.loaderName));
            },
            addTracking() {
                this.editedTracking = {id: null, freight_id: this.$props.freight.id, date: (moment().format('YYYY-MM-DD') + 'T' + moment().format('HH:mm:ss') + '.000+10:00')};
                this.showTrackingForm = true;
            },
            saveTracking() {
                this.$validator.validate().then(valid => {
                    if (!valid) return;
                    let action = (this.editedTracking.id) ? 'stock/updateFreightTracking' : 'stock/addFreightTracking';
                    this.editedTracking.date = moment(this.editedTracking.date).format('DD.MM.YYYY HH:mm:ss');
                    this.$store.commit('showProgressBar', this.loaderName);
                    this.$store.dispatch(action, this.editedTracking).then(tracking => {
                        this.$store.commit('showSnackbar', ['Трекинговая отметка успешно сохранена', 6000, 'success']);
                        
                        //Если статус подтверждает заявку, то эмитим это событие
                        if (!this.editedTracking.id && tracking && tracking.status && parseInt(tracking.status.confirm_deal)) this.$emit('change-deal-status');

                        this.getTracking(1, 100, false, false, {model: [['freight_id', '=', this.$props.freight.id]], relation: []});
                    }).catch(() => null).finally(() => {
                        this.$store.commit('hideProgressBar', this.loaderName);
                        this.showTrackingForm = false;
                    });
                });
            },
            deleteTracking(id) {
                if (!id) return;
                this.$root.$emit('z-alert', 'Удалить трекинговую отметку?', null, () => {
                    this.$store.commit('showProgressBar', this.loaderName);
                    return this.$store.dispatch('stock/deleteFreightTracking', {id: id}).then(r => {
                        this.getTracking(1, 100, false, false, {model: [['freight_id', '=', this.$props.freight.id]], relation: []});
                    }).catch(() => null).finally(() => this.$store.commit('hideProgressBar', this.loaderName));
                });
            }
        },
        created() {
            this.getFreightRouteList();
            this.$root.$on('update-freight-tracking', async (data) => {
                if (data && data.data && data.data.freight_id && this.$props.freight && parseInt(this.$props.freight.id) == parseInt(data.data.freight_id)) {
                    this.getFreightRouteList();
                    await this.getTracking(1, 100, false, false, {model: [['freight_id', '=', this.$props.freight.id]], relation: []});
                    this.$emit('change-deal-status');
                }
            });

            this.$root.$on('update-deal-form', id => {
                if (this.$props.freight && parseInt(this.$props.freight.deal_id) === parseInt(id))
                    this.getTracking(1, 100, false, false, {model: [['freight_id', '=', this.$props.freight.id]], relation: []});
            });
        },
    }
</script>
<style lang="sass">
.timeline-container
  position: relative
  display: flex
  align-items: flex-start
  justify-content: flex-start
  flex-direction: column
  padding: 20px
  #tracking-form
    align-self: flex-end
    width: 100%
  .add-btn
    align-self: flex-end
.timeline
  display: flex
  flex-direction: column
  align-items: flex-start
  justify-content: flex-start
  min-width: 400px
  .timeline-row
    display: flex
    align-items: strech
    justify-content: flex-start
    width: 100%
    .date-time
      margin-right: 5px
      height: 65px
      margin-top: 1px
      font-size: 10px
      line-height: 13px
      flex-shrink: 0
      display: flex
      color: #888
      .date
        margin-right: 10px
    .dot-container
      width: 30px
      display: flex
      align-items: flex-start
      justify-content: center
      position: relative
      flex-shrink: 0
      .dot
        width: 14px
        height: 14px
        background-color: #fff
        border-radius: 100%
        position: absolute
        top: 0px
        border: 2px solid
      .dot-line
        width: 2px
        height: 100%
        position: absolute
        top: 0px
    .timeline-content
      margin-bottom: 20px
      width: 100%
      position: relative
      .delete
        .md-button
          position: absolute
          bottom: 4px
          right: 4px
      .status
        position: relative
        margin-bottom: 6px
        .text
          height: 22px
          line-height: 22px
          font-size: 12px
          font-weight: 500
          margin-top: -4px
      .time
        width: 100%
        text-align: right
        padding: 0px 10px
      .timeline-text-content
        position: relative
        padding: 10px 14px
        border: 1px solid
        border-radius: 4px 
        font-size: 12px
        width: 100%
        font-weight: 500
        span
          color: #888
          font-weight: normal
          margin-right: 6px
  .timeline-row.last
    .dot-container
      .dot-line
        display: none
      .dot::after
        position: absolute
        top: 3px
        left: 3px
        border: 2px solid
        border-color: inherit
        content: ''
        border-radius: 50%
  .points
    background: #81D4FA
    display: inline-block
    height: 4px
    margin-top: 3px
    position: relative
    border-radius: 2px
    max-width: 100%
    &.min-width
      min-width: 50%
    .start, .end
      position: absolute
      bottom: -35px
      font-size: 11px
      &::after
        content: ''
        position: absolute
        height: 8px
        width: 1px
        background: #000
        top: -8px
        right: 50%
    .start
      left: 0
      transform: translateX(-50%)
    .end
      right: 0
      transform: translateX(50%)
    .point
      background: #29B6F6
      height: 10px
      width: 10px
      border-radius: 5px
      cursor: pointer
      display: inline-block
      position: absolute
      top: -3px
      .tooltip
        display: none
        background: rgba(97, 97, 97, 0.9)
        color: #fff
        position: absolute
        bottom: 15px
        transform: translateX(-50%)
        left: 5px
        font-size: 11px
        padding: 5px
        width: 160px
        border-radius: 2px 2px 0 0
        z-index: 5
        .md-icon
          color: #fff
        &::after
          position: absolute
          border-top: 10px solid rgba(97, 97, 97, 0.9)
          border-left: 80px solid transparent
          border-right: 80px solid transparent
          bottom: -10px
          left: 0
          content: ''
          width: 0
          height: 0
        .time
          font-size: 10px
        .stock
          font-weight: 100
      &:hover .tooltip
        display: block
    + .add-tracking
      margin-left: 15px
  .add-tracking
    position: relative
</style>


// WEBPACK FOOTER //
// ZFreightTracking.vue?739b81ca